import { mockComponent } from 'bloko/common/setupMockComponents';

export { default as Tab } from './Tab';

export default mockComponent('Tabs', null, {
    withChildren: true,
});
